<template>
  <div>
    <b-row class="m-0">
      <b-col cols="12" md="5" class="my-2">
        <div class="p-3">
          <div class="text-justify mb-3">
            <strong class="fs_16" v-text="$lang.finalReportIntuitionTitle" />
            <span
              class="text-muted lh_30"
              v-text="finalReportIntuitionCaption"
            />
          </div>
          <i :class="`far fa-check-circle mr-2`" />
          <strong class="text-right" v-html="renderScore()" />
        </div>
      </b-col>
      <b-col cols="12" md="7" class="my-2">
        <div
          v-if="score"
          class="showInChart"
          :style="{ left: score - 2 + `%`, bottom: `53%` }"
        >
          <div class="line-chart"></div>
        </div>
        <barChart
          v-if="!isloading"
          :title="''"
          :labelChart="labelChart"
          :backgroundColor="backgroundColor"
          :data="dataBar"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { pathOr } from "ramda";
import barChart from "@/components/chart/barChart.js";
export default {
  components: {
    barChart,
  },
  data() {
    return {
      backgroundColor: [
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ff0000",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",
        "#ffc107",

        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
        "#28a745f2",
      ],
      dataBar: [
        4, 5, 6, 15, 30, 37, 85, 131, 143, 181, 181, 203, 203, 172, 126, 73, 10,
        8, 5, 2,
      ],
      labelChart: [
        0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65,
        0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1,
      ],
      isloading: false,
      code: this.$route.params.code,
      intuitionData: {},
      score: 0,
      finalReportIntuitionCaption: `عمق آشنایی فرد با معارف دینی را معادل بینش در نظر گرفتیم، بینش از طریق سؤالاتی استاندارد با محتوای معارف اسلامی و احکام  در جلسه مصاحبه ارزیابی شده است، این سؤالات به صورت تصادفی تغییر می‌کرده است.`,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    renderScore() {
      const data = {
        خوب: "text-success",
        متوسط: "text-warning",
        ضعیف: "text-danger",
      };
      const score = pathOr("", ["score"], this.intuitionData);
      const state = pathOr("", ["state"], this.intuitionData);
      const cls = pathOr("text-secondary", [state], data);
      return this.$lang.finalReportIntuitionScore
        .replace("{0}", `<span class="${cls}">${score}%</span>`)
        .replace("{1}", `<span class="${cls}">${state}</span>`);
    },
    async fetchData() {
      try {
        this.isloading = true;
        this.$emit("setLoading", true);
        const url =
          this.$config.api_url +
          this.$config.report.final_report_intuition.replace("{0}", this.code);

        const response = await this.$httpService.get(url);
        this.intuitionData = {
          ...pathOr({}, ["data", "data"], response),
        };
        this.score =
          this.intuitionData && this.intuitionData.score
            ? parseInt(this.intuitionData.score)
            : 0;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$emit("setLoading", false);
        this.isloading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.showInChart {
  position: absolute;
}

.line-chart {
  background-color: springgreen;
  width: 10px;
  height: 30px;
  position: relative;

  &::after {
    bottom: -16px;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 17px solid springgreen;
    right: -5px;
  }
}
</style>
